<template>
  <!--  <div style="background-color: #eaeaea">-->
  <div style="background-color: #fff">
    <div style="display: flex;">
      <!-- 顶部工具栏     -->
      <div style="flex: 1;height: 3vh;border-bottom: 1px solid #dce3e8;">
        <div style="float: left;margin-left: 20px">
          <el-button @click="saveAll" icon="el-icon-search" round size="mini" type="">保存</el-button>
          <el-button @click="relayout" icon="el-icon-search" round size="mini" type="">重新布局</el-button>
        </div>
        <div style="float: right">
          <el-tag @click="scaleClick" type="danger"> 比例尺 ：{{ SCALE }}</el-tag>

        </div>
      </div>
    </div>


    <div style="display: flex">
      <!--  左侧工具栏    -->
      <div :style="{ height: '81vh', width: '230px',borderRight: '1px solid #dce3e8' }" id="tool">
        <div style="height: 30px">工具栏</div>
        <div id="layout" style="display: flex; flex-direction: column;">
          <div style="margin-left: 20px;height: 50px">
            <div class="node" id="startNode" v-drag>
              <i class="el-icon-video-play"></i>
              开始节点
            </div>
          </div>
          <div style="margin-left: 20px;height: 50px">
            <div class="node" id="flowNode" v-drag>
              <i class="el-icon-caret-right"></i>
              流程节点
            </div>
          </div>
          <div style="margin-left: 20px;height: 50px">
            <div class="node" id="endNode" v-drag>
              <i class="el-icon-switch-button"></i>
              结束节点
            </div>
          </div>
        </div>
      </div>


      <!--   右侧画布加节点信息面板    -->
      <div style="flex: 1">
        <div style="display: flex; flex-direction: column;">
          <!--   画布    -->
          <div style="height: 30px;border-bottom: 1px solid #dce3e8;">
            <el-input class="tName" placeholder="请输入模板名称" v-model="template.name"></el-input>
          </div>
          <div
            element-loading-background="rgba(255, 255, 255, 0.9)"
            element-loading-spinner="el-icon-loading"
            element-loading-text="拼命加载中"
            id="canvs"
            ref="canvs"
            style="height: 50vh;border-bottom: 1px solid #dce3e8;overflow:auto"
            v-loading="loading"
          >
            <svg height="1000%" id="dagSvg" width="1000%">
              <defs>
                <svg class="icon" height="200" id="start1" p-id="16910" t="1627720192120" version="1.1" viewBox="0 0 1024 1024" width="200" xmlns="http://www.w3.org/2000/svg"><path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="#F2C084" p-id="16911"></path><path d="M512 512m-443.191534 0a443.191534 443.191534 0 1 0 886.383068 0 443.191534 443.191534 0 1 0-886.383068 0Z" fill="#F3961A" p-id="16912"></path><path d="M406.168607 309.728395v404.36261c0 1.264198 1.444797 2.167196 2.528395 1.444797l350.182716-202.271604c1.083598-0.722399 1.083598-2.347795 0-2.889595l-350.182716-202.271605c-1.083598-0.541799-2.528395 0.361199-2.528395 1.625397z" fill="#FFFFFF" p-id="16913"></path><path d="M0 512C0 794.638448 229.180952 1023.8194 512 1023.8194V0C229.180952 0 0 229.180952 0 512z" fill="#FEFFFF" opacity=".1" p-id="16914"></path></svg>
                <svg class="icon" height="200" id="end" p-id="3510" t="1627866902830" version="1.1" viewBox="0 0 1024 1024" width="200" xmlns="http://www.w3.org/2000/svg"><path d="M512 554.66666667c-25.6 0-42.666667-17.066667-42.666667-42.666667V63.99999967c0-25.6 17.066667-42.666667 42.666667-42.666666s42.666667 17.066667 42.666667 42.666666v448c0 25.6-17.066667 42.666667-42.666667 42.666667z" fill="#FFBF60" p-id="3511"></path><path d="M512 959.99999967C264.533333 959.99999967 64 759.46666667 64 511.99999967c0-140.8 64-268.8 174.933333-354.133333 17.066667-12.8 42.666667-8.533333 59.733334 8.533333 12.8 17.066667 12.8 46.933333-8.533334 59.733334a359.68 359.68 0 0 0-140.8 285.866666c0 200.533333 162.133333 362.666667 362.666667 362.666667s362.666667-162.133333 362.666667-362.666667c0-110.933333-51.2-217.6-140.8-285.866666-17.066667-12.8-21.333333-42.666667-8.533334-59.733334 12.8-17.066667 42.666667-21.333333 59.733334-8.533333 110.933333 85.333333 174.933333 213.333333 174.933333 354.133333C960 759.46666667 759.466667 959.99999967 512 959.99999967z" fill="#FFBF60" p-id="3512"></path></svg>
                <svg class="icon" height="200" id="start" p-id="3657" t="1627867491290" version="1.1" viewBox="0 0 1024 1024" width="200" xmlns="http://www.w3.org/2000/svg"><path d="M512 1016.86992592c-279.62026667 0-504.86992592-225.24965925-504.86992592-504.86992592S232.37973333 7.13007408 512 7.13007408s504.86992592 225.24965925 504.86992592 504.86992592-225.24965925 504.86992592-504.86992592 504.86992592z m0-932.06755555C278.98311111 84.80237037 84.80237037 278.98311111 84.80237037 512S278.98311111 939.19762963 512 939.19762963 939.19762963 745.01688889 939.19762963 512 745.01688889 84.80237037 512 84.80237037z" fill="#FFBF60" p-id="3658"></path><path d="M473.16385185 675.11182222c-23.30168889 0-46.60337778-15.53445925-62.13783703-31.06891852-7.76722963-15.53445925-15.53445925-31.06891852-15.53445927-46.60337778V426.56047408c0-46.60337778 31.06891852-77.6722963 77.6722963-77.6722963 15.53445925 0 31.06891852 7.76722963 46.60337778 15.53445925l124.27567407 85.43952594c38.83614815 23.30168889 46.60337778 69.90506667 23.30168889 108.74121481-7.76722963 7.76722963-15.53445925 15.53445925-23.30168889 15.53445925L519.76722963 659.57736297c-15.53445925 7.76722963-31.06891852 15.53445925-46.60337778 15.53445925z m0-248.55134814V589.6722963l124.27567407-77.6722963-124.27567407-85.43952592z" fill="#FFBF60" p-id="3659"></path></svg>
                <svg class="icon" height="200" id="flow" p-id="3719" t="1627867930935" version="1.1" viewBox="0 0 1024 1024" width="200" xmlns="http://www.w3.org/2000/svg"><path d="M195.4 89.6l677.7 383c30.6 17.3 30.6 61.4 0 78.6l-677.7 383c-30.1 17-67.4-4.7-67.4-39.3L128 129C128 94.4 165.3 72.6 195.4 89.6z" fill="#FFBF60" p-id="3720"></path></svg>
              </defs>
              <g :id="'group' + item.id" :key="item.id" v-for="item in nodeData">

                <defs>
                  <svg :id="'text-' + item.id" viewBox="0 0 110 30">
                    <!--添加文字-->
                    <text
                      :id="'text' + item.id"
                      :x="Rectangle.width / 5"
                      :y="Rectangle.height * 0.7"
                      cursor="move"
                      fill=""
                      font-family="Verdana"
                      font-size="12"
                      text-anchor="start"
                    >
                      {{ item.name }}
                    </text>
                  </svg>
                </defs>
                <use :x="item.left" :xlink:href="'#text-' + item.id" :y="item.top" height="30" width="120" />
                <use :x="item.left + 5" :xlink:href="'#' + item.nodeType" :y="item.top" height="30" width="20" />
                <!--添加外点矩形-->
                <rect
                  :height="Rectangle.height + outNodeMargin * 2"
                  :id="'outRect' + item.id"
                  :transform="`translate(${item.left - outNodeMargin}, ${item.top - outNodeMargin})`"
                  :width="Rectangle.width + outNodeMargin * 2"
                  fill="transparent"
                  stroke="#E0E3E7"
                  stroke-dasharray="10"
                  stroke-width="0"
                >
                </rect>

                <!--添加矩形节点-->
                <rect
                  :height="Rectangle.height"
                  :id="'node' + item.id"
                  :transform="`translate(${item.left}, ${item.top})`"
                  :width="Rectangle.width"
                  class="rectNode"
                  cursor="move"
                  fill="transparent"
                  rx="4"
                  ry="4"
                  stroke="#E0E3E7"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1"
                >
                </rect>
                <!--                <g :id="'outCircle' + item.id">-->
                <!--                  &lt;!&ndash;添加锚点的吸附点 (上下左右）&ndash;&gt;-->
                <!--                  <circle :r="outNodeMargin" :cx="item.left + Rectangle.width / 2" :cy="item.top" fill="none" cursor="inherit" stroke="#E0E3E7" stroke-dasharray="10" stroke-width="1"></circle>-->
                <!--                  <circle :r="outNodeMargin" :cx="item.left + Rectangle.width / 2" :cy="item.top + Rectangle.height" fill="none" cursor="inherit" stroke="#E0E3E7" stroke-dasharray="10" stroke-width="1"></circle>-->
                <!--                  <circle :r="outNodeMargin" :cx="item.left" :cy="item.top + Rectangle.height / 2" fill="none" cursor="inherit" stroke="#E0E3E7" stroke-dasharray="10" stroke-width="1"></circle>-->
                <!--                  <circle :r="outNodeMargin" :cx="item.left + Rectangle.width" :cy="item.top + Rectangle.height / 2" fill="none" cursor="inherit" stroke="#E0E3E7" stroke-dasharray="10" stroke-width="1"></circle>-->
                <!--                </g>-->

                <g :id="'anchor' + item.id">
                  <!--添加锚点 (上下左右）-->
                  <circle :cx="item.left + Rectangle.width / 2" :cy="item.top" cursor="inherit" fill="transparent" r="2"></circle>
                  <circle :cx="item.left + Rectangle.width / 2" :cy="item.top + Rectangle.height" cursor="inherit" fill="transparent" r="2"></circle>
                  <circle :cx="item.left" :cy="item.top + Rectangle.height / 2" cursor="inherit" fill="transparent" r="2"></circle>
                  <circle :cx="item.left + Rectangle.width" :cy="item.top + Rectangle.height / 2" cursor="inherit" fill="transparent" r="2"></circle>
                </g>

              </g>
              <path
                :d="item.path"
                :id="item.id"
                :key="index"
                class="inPath"
                fill="none"
                marker-end="url(#arrow)"
                stroke="steelblue"
                stroke-width="2"
                v-for="(item, index) in pathPoint"
              ></path>
              <path
                :d="item.path"
                :id="'outPath' + item.id"
                :key="'outPath' + index"
                class="outPath"
                fill="transparent"
                stroke="transparent"
                stroke-width="15"
                v-for="(item, index) in pathPoint"
              ></path>

            </svg>
          </div>
          <!--   底部面板     -->
          <div style="flex: 1">
            <el-tabs type="border-card" v-model="activeName">
              <el-tab-pane label="节点信息" name="nodeInfo">
                <el-col :span="6">
                  <DataForm
                    :form-data="formData"
                    :form-label="formLabel"
                    :max="SCALE">
                  </DataForm>
                </el-col>
                <el-col :offset="1" :span="6">
                  <DataForm
                    :form-data="formData"
                    :form-label="formLabel1"
                    :max="SCALE">
                  </DataForm>
                </el-col>
              </el-tab-pane>
              <el-tab-pane label="工作组" name="groupPeople">
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>

      </div>
    </div>

    <div id="menu" v-click-outside="hiddenMenu">
      <el-card
        :body-style="{ padding: '5px' }"
        :key="index"
        @click.native="infoClick(item, index)"
        class="cardStyle"
        shadow="hover"
        size="mini"
        v-for="(item,index) in menus">
        <svg aria-hidden="true" class="icon">
          <use :href="item.icon"></use>
        </svg>
        {{ item.name }}</el-card>
    </div>
    <!--    <el-dialog-->
    <!--      title="提示"-->
    <!--      :visible.sync="dialogVisible"-->
    <!--      width="30%"-->
    <!--    >-->
    <!--      <span>当前页面未保存，是否离开当前页面</span>-->
    <!--      <span slot="footer" class="dialog-footer">-->
    <!--        <el-button @click="dialogVisible = false">取 消</el-button>-->
    <!--        <el-button type="primary" @click="dialogVisible = false">离 开</el-button>-->
    <!--      </span>-->
    <!--    </el-dialog>-->

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="scaleDialogVisible"
      title="请填写比例尺(不能为0)"
      width="30%"
    >
      <el-row>
        <span>比例尺  </span>
        <el-input-number :min="0" v-model="SCALE"></el-input-number>
      </el-row>
      <span class="dialog-footer" slot="footer">
        <el-button @click="scaleDialogCancel">取 消</el-button>
        <el-button @click="scaleDialogOk" type="primary">确 定</el-button>
      </span>
    </el-dialog>

  </div>


</template>

<script>
import { Compare, CompareArrLength } from './util/CompareObj'
import { generateUUID } from './util/UUID'
import * as d3 from 'd3'
import DataForm from './NodeDataForm'
export default {
  name: 'panel',
  components: {
    DataForm
  },
  directives: {
    drag: {
      // 指令的定义
      bind: function(el, binding, vnode) {
        const odiv = el //获取当前元素
        //获取当前的vm实例
        const that = vnode.context
        el.onmousedown = (e) => {
          //算出鼠标相对元素的位置
          const disX = e.clientX - odiv.offsetLeft
          const disY = e.clientY - odiv.offsetTop
          console.log('e.clientY', e.clientY)
          console.log('odiv.offsetTop', odiv.offsetTop)
          const parDiv = odiv.parentNode
          const newDiv = odiv.cloneNode(true)
          parDiv.appendChild(newDiv)
          let left = ''
          let top = ''
          document.onmousemove = (e) => {
            //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
            left = e.clientX - disX
            top = e.clientY - disY
            //绑定元素位置到positionX和positionY上面
            if (top < 0 || left < odiv.offsetLeft + 230 - 20) {
              newDiv.style.cursor = 'not-allowed'
              that.appendNode = false
            } else {
              newDiv.style.cursor = 'inherit'
              that.appendNode = true
            }
            //移动当前元素
            newDiv.style.left = left + 'px'
            newDiv.style.top = top + 'px'
          }
          document.onmouseup = (e) => {
            document.onmousemove = null
            document.onmouseup = null
            that.appendSvgNode(newDiv, parDiv, e, odiv)
          }
        }
      }
    },
    clickOutside: {
      // 初始化指令
      bind(el, binding, vnode) {
        function clickHandler(e) {
          // 这里判断点击的元素是否是本身，是本身，则返回
          if (el.contains(e.target)) {
            return false
          }
          // 判断指令中是否绑定了函数
          if (binding.expression) {
            // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
            binding.value(e)
          }
        }
        // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
        el.__vueClickOutside__ = clickHandler
        document.addEventListener('click', clickHandler)
      },
      update() {},
      unbind(el, binding) {
        // 解除事件监听
        document.removeEventListener('click', el.__vueClickOutside__)
        delete el.__vueClickOutside__
      }
    }
  },
  data() {
    return {
      //new
      old: {},
      dialogVisible: false,
      scaleDialogVisible: false,
      loading: true,
      templateId: '',
      template: {},
      SCALE: '',
      OldSCALE: '',
      activeName: 'nodeInfo',
      formData: {},
      formLabel: [
        {
          label: '节点名称',
          prop: 'name',
          content: '当前节点的名称',
          readonly: false
        },
        {
          label: '比例天数',
          prop: 'scaleDays',
          readonly: false,
          type: 'number',
          content: '当前比例尺下的比例天数，实际天数 = 实际总天数 / 比例尺 * 比例天数',
          min: 0
        },
        {
          label: '开始偏移',
          prop: 'advanceDays',
          content: '相对于当前节点的开始时间，提前/延后天数。\n【正数为延后,负数为提前】\n根据选择偏移类型为固定偏移、比例偏移来确定偏移天数是按比例天数计算还是固定天数计算。\n比如选择偏移类型为“固定偏移”，开始偏移天数给值“-5”，表示当前节点的开始时间比预计提前5天，无论 实际总天数/比例尺 的实际比例为多少',
          type: 'number',
          min: -1000
        },
        {
          label: 'WBS',
          prop: 'wbspath',
          content: '当前节点的wbspath',
          readonly: false
        }
      ],
      formLabel1: [
        {
          label: '偏移类型',
          prop: 'offsetType',
          content: '如果选择偏移天数，下拉选择【固定偏移】、【比例偏移】来确定天数偏移的计算方式',
          options: [
            {
              value: 'f',
              label: '固定偏移'
            }, {
              value: 's',
              label: '比例偏移'
            }
          ],
          type: 'select'
        },
        {
          label: '固定天数',
          prop: 'fixedDays',
          readonly: false,
          type: 'number',
          content: '当前节点所占天数固定，无论实际比例为多少，都不影响该节点的所占天数',
          min: 0
        },
        {
          label: '结束偏移',
          prop: 'delayedDays',
          readonly: false,
          type: 'number',
          content: '相对于当前节点的“结束时间”，提前/延后天数。\n【正数为延后,负数为提前】\n根据选择偏移类型为固定偏移、比例偏移来确定偏移天数是按比例天数计算还是固定天数计算。\n比如选择偏移类型为“固定偏移”，开始偏移天数给值“-5”，表示当前节点的完成时间比预计提前5天，无论 实际总天数/比例尺 的实际比例为多少',
          min: -1000
        },
        {
          label: '父级名称',
          prop: 'parentName',
          content: '当前节点的父节点的名称，便于区分同名节点,不可编辑',
          readonly: true
        }


      ],
      appendNode: false, //是否在画布添加节点
      scrollTop: 0, //画布滚动高度
      Rectangle: {
        height: 30, //节点形状
        width: 120
      },
      outNodeMargin: 10, //节点的外点边距
      pointData: [],
      nodeIndex: -1,
      nodeData: [],
      oldNodeData: [],
      eageList: [],
      oldEdgeList: [],
      pathPoint: [], //{id, path}
      //是否画线
      isPath: false,
      pathToNode: {},
      anchorArray: [],
      mousePoint: [],
      menus: [
        {
          name: '删除元素',
          icon: '#icon-shanchu-copy'
        },
        {
          name: '置为开始',
          icon: '#icon-qidong-copy'
        },
        {
          name: '置为结束',
          icon: '#icon-quxiao1'
        }
      ],
      currentClick: {},
      //old
      dragFlag: true,
      dragClone: '',
      offsetX: 0,
      offsetY: 0,
      dragWidth: 0,
      dragPanelClone: '',
      toolWidth: 230,
      toolHeight: 0,
      Margin: {
        left: 20,
        right: 20,
        top: 20,
        bottom: 20
      },
      nodes: [
        { name: '开始节点', icon: '', disabled: false },
        { name: '结束节点', icon: '', disabled: false },
        { name: '普通节点', icon: '', disabled: false },
        { name: '连接线', icon: '', disabled: false }
      ]
    }
  },
  watch: {
    nodeData: {
      handler: function(newVal, oldVal) {
        this.addNodeEvent()
      },
      deep: true
    }
    // eageList: {
    //   handler: function(newVal, oldVal) {
    //     console.log('newVal:', newVal)
    //     console.log('oldVal:', oldVal)
    //     console.log('this.nodeData', this.nodeData)
    //     this.getPathPointArr(this.eageList)
    //   },
    //   deep: true
    // }
  },
  beforeRouteLeave(to, from, next) {
    if (this.checkSaveOrUpdate()) {
      next(true)
    } else {
      this.dialogVisible = true
      if (this.dialogVisible) {
        this.$confirm('数据未保存，确定离开当前页面?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          next(true)
        }).catch(() => {
          next(false)
        })
      }
    }

  },
  created() {
    this.initDatas()
    /**
       * 以下是为了解决在火狐浏览器上推拽时弹出tab页到搜索问题
       * @param event
       */
    if (this.isFirefox()) {
      document.body.ondrop = function(event) {
        // 解决火狐浏览器无法获取鼠标拖拽结束的坐标问题
        // mousePosition.left = event.layerX
        // mousePosition.top = event.clientY - 50
        event.preventDefault()
        event.stopPropagation()
      }
    }

  },
  mounted() {
    this.init()
    setTimeout(() => {
      this.addNodeEvent()
      this.getPathPointArr(this.eageList)
      console.log(this.eageList, 'eeeee')
      if (this.eageList === null || this.eageList.length === 0) {
        this.relayout()
      }
      this.loading = false
    }, 500)
    if (this.SCALE === 0) {
      this.scaleDialogVisible = true
    }
  },
  methods: {
    //初始化数据
    initDatas() {
      const template = sessionStorage.getItem('template')
      this.template = JSON.parse(template)
      this.old.template = JSON.parse(template)
      this.templateId = this.template.id
      this.SCALE = this.template.scale
      this.getNodeList(this.templateId)
      this.getEdgeList(this.templateId)
    },
    //确认修改比例尺
    scaleDialogOk() {
      if (this.SCALE !== 0) {
        this.scaleDialogVisible = false
      }
    },
    //取消修改比例尺
    scaleDialogCancel() {
      if (this.SCALE !== 0 && this.OldSCALE !== 0) {
        this.scaleDialogVisible = false
        this.SCALE = this.OldSCALE
      }

    },
    //修改比例尺
    scaleClick() {
      this.OldSCALE = this.SCALE
      this.scaleDialogVisible = true
    },
    // 自定义菜单的点击事件
    infoClick(item, index) {
      const thisEle = this.currentClick
      switch (item.name) {
        case '删除元素':
          this.deleteElement(item.name, thisEle)
          this.hiddenMenu()
          break
        case '置为开始':
          this.changeNodeType(item.name, thisEle)
          this.hiddenMenu()
          break
        case '置为结束':
          this.changeNodeType(item.name, thisEle)
          this.hiddenMenu()
          break
        case '置为流程':
          this.changeNodeType(item.name, thisEle)
          this.hiddenMenu()
          break
      }
    },
    //切换节点类型
    changeNodeType(name, element) {
      console.log('222222')
      let count = 0
      let nodeType = 'flow'
      if (name === '置为开始') {
        nodeType = 'start'
        this.nodeData.find(item => {
          if (item.nodeType === nodeType) {
            count++
          }
        })
        if (count > 0) {
          this.$messageInfo('warn', '只能有一个开始节点')
          return
        }

      } else if (name === '置为结束') {
        nodeType = 'end'
        this.nodeData.find(item => {
          if (item.nodeType === nodeType) {
            count++
          }
        })
        if (count > 0) {
          this.$messageInfo('warn', '只能有一个结束节点')
          return
        }

      }
      const id = element.attr('id').replace('node', '')
      this.nodeData.find(item => {
        if (item.id === id && item.nodeType !== nodeType) {
          item.nodeType = nodeType
          this.$messageInfo('success', '类型变更成功')
        }
      })

    },
    // 删除元素
    deleteElement(name, element) {
      const id = element.attr('id')
      if (name === '删除元素') {
        console.log('element', id.indexOf('path'))
        //判断删除的是路径还是
        if (id.indexOf('path') > -1) {
          const pathId = id.replace('outPath', '')
          this.deletPath(id)
          this.deletPath(pathId)
          this.deleteEdge(pathId)
          //防止自动选中下一个元素
          this.canceChooseNode()
          this.cancelChoosePath()
        } else if (id.indexOf('node') > -1) {
          //删除节点及相关边
          this.deleteNode(id)
        }
      }
    },

    //隐藏菜单
    hiddenMenu() {
      const menu = document.querySelector('#menu')
      if (menu) {
        menu.style.display = 'none'
      }

    },
    /**
       *重新布局
       */
    relayout() {
      // let line = 1
      for (const a in this.nodeData) {
        const x = 200 * (parseInt(a) % 6) + 20
        // if (parseInt(a) > 6 * line) {
        //   x = 20
        //   line++
        // }
        this.nodeData[a].left = x
        this.nodeData[a].top = 100 * (parseInt(parseInt(a) / 6) + 1) + 300
        console.log(parseInt(parseInt(a) / 6))
      }
    },
    //saveAll
    saveAll() {
      //是否有孤点
      const haveSingleNode = this.checkHaveSingleNode()
      if (!haveSingleNode) {
        //是否只有一个开始，一个结束
        const onlyOneStartOneEnd = this.checkOneStartOneEnd()
        if (onlyOneStartOneEnd) {
          //是否没有开始节点的前驱
          const startNode = this.getNodeByType('start')
          const noInStartNode = startNode !== undefined && this.checkNodeInOut(startNode.id, 'start')
          if (noInStartNode) {
            //是否没有结束节点的后继
            const endNode = this.getNodeByType('end')
            const noOutEndNode = endNode !== undefined && this.checkNodeInOut(endNode.id, 'end')
            if (noOutEndNode) {
              //获取全部路径
              this.getAllPath()
              //是否所有路径的比例和满足比例尺
              const scaleGood = this.checkAllPathScale()
              if (scaleGood) {
                if (this.checkSaveOrUpdate()) {
                  this.$messageInfo('info', '无改变无需保存')
                } else {
                  this.$confirmInfo('确定要保存模板【' + this.template.name + '】？', 'info').then(res => {
                    this.saveNodeInfo()
                  }).catch(err => {
                    this.$messageInfo('info', '取消操作')
                  })

                }
              }
            }
          }
        }
      }





    },
    //是否满足保存条件 true 未改动  false 有改动
    checkSaveOrUpdate() {
      let flag = false
      this.template.operate = ''
      this.template.operateNode = ''
      this.template.operateEdge = ''
      //判断是否有变动
      // console.log(this.compareTemplate())
      // console.log(this.compareNodes())
      if (!(this.compareTemplate() && this.compareNodes() && this.compareEdges())) {
        //升版本
        this.template.operate = 'insert'
      } else {
        if (this.template.operateNode === 'update' || this.template.operateEdge === 'update') {
          //只是更新
          this.template.operate = 'update'
        } else {
          flag = true
        }
      }
      return flag
    },
    //比较模板信息
    compareTemplate() {
      return this.template.name === this.old.template.name && this.template.SCALE === this.old.template.SCALE
    },
    //比较节点信息
    compareNodes() {
      let flag = true
      //首先判断长度
      if (CompareArrLength(this.nodeData, this.old.nodeData)) {
        const newNode = new Map()
        const oldNode = new Map()
        this.nodeData.find(item => {
          delete item.next
          newNode.set(item.id, item)
        })
        this.old.nodeData.find(item => {
          oldNode.set(item.id, item)
        })
        try {
          newNode.forEach((value, key) => {
            if (oldNode.has(key)) {
              const node = oldNode.get(key)
              const node1 = newNode.get(key)
              //判断两个节点对象是否相等
              if (!Compare(node, node1)) {
                if (node.top === node1.top && node.left === node1.left) {
                  throw new Error()
                } else {
                  const temp1 = Object.assign({}, node)
                  const temp2 = Object.assign({}, node1)
                  temp1.top = 0
                  temp1.left = 0
                  temp2.top = 0
                  temp2.left = 0
                  if (Compare(temp1, temp2)) {
                    //只有坐标改变
                    if (this.template.operateNode === '') {
                      this.template.operateNode = 'update'
                    }
                  } else {
                    throw new Error()
                  }
                }
              }
            } else {
              throw new Error()
            }
          })
        } catch (e) {
          flag = false
        }

      } else {
        flag = false
      }
      return flag
    },
    //比较边关系
    compareEdges() {
      let flag = true
      //首先判断长度
      if (CompareArrLength(this.eageList, this.old.eageList)) {
        const newEdge = new Map()
        const oldEdge = new Map()
        this.eageList.find(item => {
          delete item.next
          newEdge.set(item.id, item)
        })
        this.old.eageList.find(item => {
          oldEdge.set(item.id, item)
        })
        for (const [key, value] of newEdge) {
          console.log(key, value)
          if (oldEdge.has(key)) {
            const edge = oldEdge.get(key)
            const edge1 = newEdge.get(key)
            //判断两个节点对象是否相等
            if (!Compare(edge, edge1)) {
              if (edge.fromPos === edge1.fromPos && edge.toPos === edge1.toPos) {
                return false
              } else {
                const temp1 = Object.assign({}, edge)
                const temp2 = Object.assign({}, edge1)
                temp1.fromPos = 0
                temp1.toPos = 0
                temp2.fromPos = 0
                temp2.toPos = 0
                if (Compare(temp1, temp2)) {
                  //只有坐标改变
                  if (this.template.operateEdge === '') {
                    this.template.operateEdge = 'update'
                  }
                } else {
                  return false
                }
              }
            }
          } else {
            return false
          }
        }
      } else {
        flag = false
      }
      return flag
    },

    //保存请求后台
    saveNodeInfo() {
      const that = this
      const data = this.template
      data.scale = this.SCALE
      data.nodes = this.nodeData
      data.edges = this.eageList
      this.$post('/fesback/projectTemplate/saveTemplateAllNodes.z', data).then(response => {
        console.log('fna', response)
        if (response.success) {
          sessionStorage.removeItem('template')
          sessionStorage.setItem('template', JSON.stringify(response.data))
          that.initDatas()
          that.$messageInfo('success', '保存成功')
        }
      })
        .catch(function(error) {
          that.$messageInfo('error', '系统异常：' + error)
        })
    },


    //是否满足有且仅有一个开始节点、一个结束节点
    checkOneStartOneEnd() {
      let countStart = 0
      let countEnd = 0
      let msg = ''
      let flag = false
      this.nodeData.forEach(item => {
        if (item.nodeType === 'start') {
          countStart++
        } else if (item.nodeType === 'end') {
          countEnd++
        }
      })
      if (countStart === 1 && countEnd === 1) {
        flag = true
      } else {
        flag = false
        if (countStart === 0) {
          msg = '需要一个开始节点'
        } else if (countStart > 1) {
          msg = '只需要一个开始节点'
        }
        if (countEnd === 0) {
          msg = '需要一个结束节点'
        } else if (countEnd > 1) {
          msg = '只需要一个结束节点'
        }
        this.$messageInfo('error', msg)
      }
      return flag
    },
    //获取开始\结束节点
    getNodeByType(type) {
      return this.nodeData.find(item => {
        return item.nodeType === type
      })
    },
    //根据id获取节点信息
    getNodeInfoByid(id) {
      return this.nodeData.find(item => {
        return item.id === id
      })
    },
    //开始节点只有出，结束节点只有入
    checkNodeInOut(id, type) {
      let flag = true
      if (type === 'start') {
        for (const i in this.eageList) {
          if (this.eageList[i].toId === id) {
            this.$messageInfo('error', '存在指向开始节点的线，请删除')
            flag = false
          }
        }
      } else if (type === 'end') {
        for (const i in this.eageList) {
          if (this.eageList[i].fromId === id) {
            this.$messageInfo('error', '存在由结束节点的指出的线，请删除')
            flag = false
          }
        }
      }
      return flag
    },
    //检查是否有孤点
    checkHaveSingleNode() {
      const nodeUse = []
      const nodeUnuse = []
      let name = ''
      let flag = false
      this.eageList.forEach(item => {
        nodeUse.push(item.fromId)
        nodeUse.push(item.toId)
      })
      this.nodeData.forEach((item) => {
        if (!nodeUse.includes(item.id)) {
          nodeUnuse.push(item)
          name += ('【' + item.name + '】 ')
        }
      })
      if (nodeUnuse.length > 0) {
        flag = true
        this.$messageInfo('error', name + '为孤点，请建立关系')
      }
      return flag
    },
    //组装节点数据 --next
    combineNodeData() {
      this.nodeData.forEach(item => {
        delete item.next
      })
      this.eageList.forEach(item => {
        const nodeFrom = this.getNodeInfoByid(item.fromId)
        const nodeTo = this.getNodeInfoByid(item.toId)
        if (nodeFrom.next === undefined) {
          nodeFrom.next = []
        }
        nodeFrom['next'].push(nodeTo)
      })
      console.log('test', this.nodeData)
    },
    //检查是否闭环
    checkCloseLoop(fromId, toId) {
      this.combineNodeData()
      //后继节点数组
      const successorNode = []
      const toNode = this.getNodeInfoByid(toId)
      this.getAllSuccessorNode(toNode, successorNode)
      console.log('后继节点', successorNode)
      return successorNode.indexOf(fromId) > -1
    },
    //递归查找节点的所有后继节点
    getAllSuccessorNode(toNode, successorNode) {
      if (toNode.next !== undefined && toNode.next.length > 0) {
        toNode.next.forEach(item => {
          successorNode.push(item.id)
          this.getAllSuccessorNode(item, successorNode)
        })
      }
      return successorNode
    },
    //获取所有路线
    getAllPath() {
      this.combineNodeData()
      const nodeListRow = []
      const nodeListCol = []
      const node = this.getNodeByType('start')
      nodeListRow.push(node)
      if (node.next === undefined) {
        nodeListCol.push(nodeListRow)
        this.$messageInfo('error', '路线获取错误')
      } else {
        this.foreachChild(node.next, nodeListRow, nodeListCol)
      }
      console.log('矩阵', nodeListCol)
      return nodeListCol
    },
    //递归
    foreachChild(toNodeList, nodeListRow, nodeListCol) {
      toNodeList.forEach(item => {
        let goOnList = []
        goOnList = this.deepCopy(nodeListRow)
        goOnList.push(item)
        if (item.next === undefined) {
          nodeListCol.push(goOnList)
        } else {
          this.foreachChild(item.next, goOnList, nodeListCol)
        }
      })

    },
    //从开始到结束的任一路径比例，固定天数和等于比例尺
    //从开始到任一可达非结束节点的比例，固定天数和小于比例尺
    checkAllPathScale() {
      let flag = true
      const pathList = this.getAllPath()
      for (const i in pathList) {
        let msg = ''
        let pathSacle = 0
        let lastType = ''
        const pathNodeName = []
        for (const j in pathList[i]) {
          pathSacle += (pathList[i][j].scaleDays + pathList[i][j].fixedDays)
          lastType = pathList[i][j].nodeType
          if (pathNodeName.indexOf(pathList[i][j].id) > -1) {
            flag = false
            this.$messageInfo('error', '存在闭环，关键节点名称：' + pathList[i][j].name)
            break
          }
          pathNodeName.push(pathList[i][j].id)
          if (+j === 0) {
            msg = pathList[i][j].name
          } else {
            msg += ('--->' + pathList[i][j].name)
          }
        }
        if (!flag)
          break
        if (lastType === 'end') {
          if (pathSacle !== this.SCALE) {
            flag = false
            this.$messageInfo('error', '路径' + msg + '天数和为' + pathSacle + '不等于比例尺天数' + this.SCALE)
            break
          }
        } else {
          if (pathSacle > this.SCALE) {
            flag = false
            this.$messageInfo('error', '非结束路径' + msg + '天数和为' + pathSacle + '不等于比例尺天数' + this.SCALE)
            break
          }
        }
      }
      return flag
    },

    //深拷贝
    deepCopy(obj) {
      const newObj = obj.constructor === Array ? [] : {} //判断是深拷贝对象还是数组
      for (const i in obj) {
        if (typeof obj[i] === 'object') {
          newObj[i] = Object.assign({}, obj[i])//  如果要拷贝的对象的属性依然是个复合类型，递归
        } else {
          newObj[i] = obj[i]
        }
      }
      return newObj
    },

    //获取节点
    getNodeList(templateId) {
      const that = this
      const data = {
        templateId: templateId
      }
      // that.config.loading = true
      this.$post('/fesback/projectTemplate/getTemplateAllNodes.z', data).then(response => {
        console.log('response', response)
        that.nodeData = response.data
        that.old.nodeData = this.deepCopy(response.data)
      })
        .catch(function(error) {
          that.$messageInfo('error', '系统异常：' + error)
        })
    },
    //获取边
    getEdgeList(templateId) {
      const that = this
      const data = {
        templateId: templateId
      }
      // that.config.loading = true
      this.$post('/fesback/projectTemplate/getTemplateAllEdges.z', data).then(response => {
        that.eageList = response.data
        that.old.eageList = this.deepCopy(response.data)
        // if (this.eageList.length > 0) {
        //   this.getPathPointArr(this.eageList)
        // }

        // that.config.loading = false
      })
        .catch(function(error) {
          that.$messageInfo('error', '系统异常：' + error)
        })
    },
    //删除节点
    deleteNode(nodeId) {
      const id = nodeId.replace('node', '')
      for (let i = this.nodeData.length - 1; i >= 0; i--) {
        if (this.nodeData[i].id === id) {
          this.nodeData.splice(i, 1)
        }
      }
      //删除节点相关边
      for (let i = this.eageList.length - 1; i >= 0; i--) {
        if (this.eageList[i].fromId === id || this.eageList[i].toId === id) {
          this.eageList.splice(i, 1)
        }
      }
      for (let i = this.pathPoint.length - 1; i >= 0; i--) {
        if (this.pathPoint[i].id.indexOf(id) > -1) {
          this.pathPoint.splice(i, 1)
        }
      }
    },
    //删除边
    deleteEdge(pathId) {
      const edge = pathId.replace('path', '').split('-')
      if (edge.length > 1) {
        const fromId = edge[0]
        const toId = edge[1]
        for (let i = this.eageList.length - 1; i >= 0; i--) {
          if (this.eageList[i].fromId === fromId && this.eageList[i].toId === toId) {
            this.eageList.splice(i, 1)
          }
        }
      }

    },
    //删除路径
    deletPath(id) {
      // d3.select('#' + id).remove()
      for (let i = this.pathPoint.length - 1; i >= 0; i--) {
        if (this.pathPoint[i].id === id) {
          this.pathPoint.splice(i, 1)
        }
      }
      // svg.remove(path)
    },
    //是否有路线
    havePath(id) {
      let flag = false
      for (let i = this.pathPoint.length - 1; i >= 0; i--) {
        if (this.pathPoint[i].id === id) {
          flag = true
          break
        }
      }
      return flag
    },
    //更新路径属性
    updatePath(id, key, value) {
      for (let i = this.pathPoint.length - 1; i >= 0; i--) {
        if (this.pathPoint[i].id === id) {
          this.pathPoint[i][key] = value
          break
        }
      }
    },
    //获取路径坐标点
    getPathPointArr(edge) {
      const lineGenerator = d3.line()
      for (const item in edge) {
        let obj = {}
        const arr = []
        const from = this.getAnchorPos(edge[item].fromId, edge[item].fromPos)
        console.log('from', from)
        const to = this.getAnchorPos(edge[item].toId, edge[item].toPos)
        console.log('to', to)
        arr.push(from)
        arr.push(to)
        obj = {
          id: 'path' + edge[item].fromId + '-' + edge[item].toId,
          path: lineGenerator(arr)
        }
        this.deletPath(obj.id)
        this.pathPoint.push(obj)
      }
      //添加路径点击事件
      setTimeout(() => {
        this.pathPoint.forEach(item => {
          this.addPathEvent(item.id)
        })
      }, 500)

    },
    //添加路径点击事件
    addPathEvent(id) {
      // console.log('clickPath', id)
      const path = d3.selectAll('#outPath' + id)
      path.on('click', () => {
        console.log('clickPath', id)
        this.canceChooseNode()
        this.cancelChoosePath()
        d3.select('#' + id)
          .attr('stroke', 'red')
          .attr('stroke-width', '4')
      })
        .on('contextmenu', () => {

          this.canceChooseNode()
          this.cancelChoosePath()
          d3.select('#' + id)
            .attr('stroke', 'red')
            .attr('stroke-width', '4')

          this.currentClick = path
          this.menus = [
            {
              name: '删除元素',
              icon: '#icon-shanchu-copy'
            }
          ]
          //弹出菜单
          const menu = document.querySelector('#menu')
          d3.event.preventDefault()
          // 根据事件对象中鼠标点击的位置，进行定位
          menu.style.left = d3.event.x + 'px'
          menu.style.top = d3.event.y + 'px'
          // 改变自定义菜单的隐藏与显示
          menu.style.display = 'block'
        })
    },
    //获取锚点坐标
    getAnchorPos(id, pos) {
      const arr = []
      const node = d3.select('#node' + id)
      console.log('nodeeee', pos)
      const xy = this.getGXY(node)
      let x = parseInt(xy[0])
      let y = parseInt(xy[1])
      switch (pos) {
        case 'T':
          x = x + this.Rectangle.width / 2
          break
        case 'B':
          x = x + this.Rectangle.width / 2
          y = y + this.Rectangle.height
          break
        case 'L':
          y = y + this.Rectangle.height / 2
          break
        case 'R':
          x = x + this.Rectangle.width
          y = y + this.Rectangle.height / 2
          break
        default:
          x = 0
          y = 0
      }
      arr.push(x)
      arr.push(y)
      return arr

    },
    //取消所有节点的选中状态
    canceChooseNode() {
      d3.selectAll('.rectNode').attr('stroke', '#E0E3E7')
    },
    //取消所有线的选中状态
    cancelChoosePath() {
      d3.selectAll('.inPath')
        .attr('stroke', 'steelblue')
        .attr('stroke-width', '2')
    },
    getNodeDataById(id) {
      this.nodeData.forEach(item => {
        if (item.id === id) {
          this.formData = item
        }

      })
    },
    //获取锚点
    getFourAnchor(g, id) {
      const arr = []
      const node = d3.select('#node' + id)
      const xy = this.getGXY(node)
      const x = parseInt(xy[0])
      const y = parseInt(xy[1])
      arr.push({ id: id, xy: [x + this.Rectangle.width / 2, y], pos: 'T' })
      arr.push({ id: id, xy: [x + this.Rectangle.width / 2, y + this.Rectangle.height], pos: 'B' })
      arr.push({ id: id, xy: [x, y + this.Rectangle.height / 2], pos: 'L' })
      arr.push({ id: id, xy: [x + this.Rectangle.width, y + this.Rectangle.height / 2], pos: 'R' })
      return arr
    },
    //每个节点添加事件
    addEventByGroup(g, id) {
      const self = this
      // const outCircleG = g.select('#outCircle' + id)
      const anchorG = g.select('#anchor' + id)
      //添加锚点显示事件
      g.on('mouseover', function() {
        anchorG.selectAll('circle').attr('fill', '#000')
        g.selectAll('circle').attr('cursor', 'crosshair')
        self.anchorArray = self.getFourAnchor(g, id)
      })
        .on('mouseout', function() {
          g.select('#anchor' + id).selectAll('circle').attr('fill', 'none')
          g.selectAll('circle').attr('cursor', 'inherit')
          self.anchorArray = []
        })
        //节点加事件
      const node = g.select('#node' + id)
      node.on('click', () => {
        self.canceChooseNode()
        self.cancelChoosePath()
        node.attr('stroke', 'blue')
        self.getNodeDataById(id)
      })
        .on('contextmenu', () => {
          self.canceChooseNode()
          self.cancelChoosePath()
          node.attr('stroke', 'blue')
          self.getNodeDataById(id)
          this.currentClick = node
          this.menus = [
            {
              name: '删除元素',
              icon: '#icon-shanchu-copy'
            },
            {
              name: '置为开始',
              icon: '#icon-qidong-copy'
            },
            {
              name: '置为流程',
              icon: '#icon-qidong-copy'
            },
            {
              name: '置为结束',
              icon: '#icon-quxiao1'
            }
          ]
          //弹出菜单
          const menu = document.querySelector('#menu')
          d3.event.preventDefault()
          // 根据事件对象中鼠标点击的位置，进行定位
          menu.style.left = d3.event.x + 'px'
          menu.style.top = d3.event.y + 'px'
          // 改变自定义菜单的隐藏与显示
          menu.style.display = 'block'
        })

      const nodeDrag = d3.drag()
        .on('start', nodeDragStart) // 拖动开始，触发一次
        .on('drag', nodeDraging) // 拖动中，触发多次
        .on('end', nodeDragEnd) // 拖动结束，触发一次
      node.call(nodeDrag)
      let oldNode = []
      let offsetX = 0
      let offsetY = 0
      function nodeDragStart() {
        oldNode = self.getGXY(node)
        offsetX = d3.event.x - oldNode[0]
        offsetY = d3.event.y - oldNode[1]
        console.log('id', id)
      }
      function nodeDraging() {
        self.updateNodeData(id, d3.event.x - offsetX, d3.event.y - offsetY, '')
        self.getPathPointArr(self.eageList)
      }
      function nodeDragEnd() {
        if (d3.event.x < self.outNodeMargin || d3.event.y < self.outNodeMargin) {
          console.log('oldNode', oldNode)
          self.updateNodeData(id, parseInt(oldNode[0]), parseInt(oldNode[1]), '')
          self.getPathPointArr(self.eageList)
          self.$messageInfo('error', '警告')
        } else {
          self.updateNodeData(id, d3.event.x - offsetX, d3.event.y - offsetY, '')
          self.getPathPointArr(self.eageList)
        }
      }
      this.circleAnchorDrag(g, id)

    },
    //获取最近的锚点坐标
    getLeastPoint(array, sourceArr) {
      //  todo
      console.log('nowArray', array)
      console.log('sourceArr', sourceArr)
      let min = 0
      let index = 0
      for (const a in sourceArr) {
        const x = sourceArr[a].xy[0] - array[0]
        const y = sourceArr[a].xy[1] - array[1]
        const temp = Math.sqrt(x * x + y * y)
        console.log('a', typeof a)
        if (a === '0') {
          min = temp
          index = a
        } else {
          if (min > temp) {
            min = temp
            console.log('min', min)
            index = a
          }

        }
      }
      return sourceArr[index]

    },
    getNodeAnchorPosByXY(id, x, y) {
      console.log('mouseX', x)
      console.log('mouseY', y)
      let pos = ''
      const node = d3.select('#node' + id)
      const xy = this.getGXY(node)
      const nodeX = parseInt(xy[0])
      const nodeY = parseInt(xy[1])
      if (x - nodeX === this.Rectangle.width / 2) {
        if (nodeY === y)
          pos = 'T'
        else
          pos = 'B'
      } else if (x === nodeX) {
        pos = 'L'
      } else {
        pos = 'R'
      }
      return pos
    },
    //拖动锚点画线
    circleAnchorDrag(g, id) {
      let pointArray = []
      const self = this
      let pathId = ''
      let fromPos = ''
      const lineGenerator = d3.line()
      const dragPoint = d3.drag()
        .on('start', dragedPointStart) // 拖动开始，触发一次
        .on('drag', dragPointing) // 拖动中，触发多次
        .on('end', dragPointEnd) // 拖动结束，触发一次
        //
      g.select('#anchor' + id).selectAll('circle')
        .call(dragPoint)
      function dragedPointStart(d, i, a) {
        self.isPath = true
        self.dragClone = d3.select(this)
          .clone(true)
          //获取起始节点[x，y]
        const array = [parseInt(self.dragClone.attr('cx')), parseInt(self.dragClone.attr('cy'))]
        pointArray = []
        pointArray.push(array)
        fromPos = self.getNodeAnchorPosByXY(id, array[0], array[1])
        console.log('shsiz ', pointArray)
        // drawLine((pointArray))
      }
      function dragPointing() {
        // pathId = 'path' + id + '-' + self.pathToNode.id
        pathId = 'path' + id + '-' + 'temp'
        let array = [d3.event.x, d3.event.y]

        console.log('shsiz ', pointArray)
        self.deletPath(pathId)
        //获取吸附点
        if (self.anchorArray.length > 0) {
          self.pathToNode = self.getLeastPoint(array, self.anchorArray)
          array = self.pathToNode.xy
          // pathId = 'path' + id + '-' + self.pathToNode.id
        }
        if (pointArray.length > 1) {
          pointArray.pop()
        }
        pointArray.push(array)
        self.pathPoint.push({
          id: pathId,
          path: lineGenerator(pointArray)
        })
        console.log('self.pathPoint', self.pathPoint)
        // drawLine((pointArray))
      }
      function dragPointEnd() {
        if (self.pathToNode.id === id) {
          self.deletPath(pathId)
          self.$messageInfo('error', '请将线连接到其他节点上')
        } else {
          if (self.checkCloseLoop(id, self.pathToNode.id)) {
            self.deletPath(pathId)
            self.$messageInfo('error', '若建立当前关系则存在闭环')
          } else {
            const newPathId = 'path' + id + '-' + self.pathToNode.id
            if (!self.havePath(newPathId)) {
              self.updatePath(pathId, 'id', newPathId)
              const obj = {
                id: newPathId,
                fromId: id,
                fromPos: fromPos,
                toId: self.pathToNode.id,
                toPos: self.pathToNode.pos,
                compareValue: null,
                currentPage: null,
                limit: null,
                pagePerCount: null,
                rowKey: null,
                start: null,
                startIndex: null,
                t: null,
                templateId: self.templateId,
                token: null
              }
              self.eageList.push(obj)
            } else {
              self.deletPath(pathId)
              self.$messageInfo('error', '当前两节点间已经有连接关系，请勿重复连线')
            }
          }

        }
        self.dragClone.remove()
        self.isPath = false
        self.pathToNode = {}
      }
      // g.select('#outCircle' + id).selectAll('circle')
      //   .on('mouseover', () => {
      //     if (self.isPath) {
      //       if (pointArray.length > 1) {
      //         pointArray.pop()
      //       }
      //       const array = [parseInt(this.attr('cx')), parseInt(this.attr('cy'))]
      //       pointArray.push(array)
      //       self.deletPath(pathId)
      //       self.pathPoint.push({
      //         id: pathId,
      //         path: lineGenerator(pointArray)
      //       })
      //     }
      //   })
    },
    //根据id改变数据
    updateNodeData(id, left, top, text) {
      for (const a in this.nodeData) {
        if (id === this.nodeData[a].id) {
          if (left > 0) {
            this.nodeData[a].left = left
          }
          if (top > 0) {
            this.nodeData[a].top = top
          }
          if (text !== '') {
            this.nodeData[a].name = text
          }
          break
        }

      }

    },
    //给节点添加事件
    addNodeEvent() {
      for (const a in this.nodeData) {
        const id = this.nodeData[a].id
        const g = d3.select('#group' + id)
        this.addEventByGroup(g, id)

      }
    },
    // 是否是火狐浏览器
    isFirefox() {
      const userAgent = navigator.userAgent
      if (userAgent.indexOf('Firefox') > -1) {
        return true
      }
      return false
    },
    //初始化一些东西
    init() {
      //获取svg
      const svg = d3.select('#dagSvg')
      //添加defs标签
      const defs1 = svg.append('defs')
      //添加marker标签及其属性
      const arrowMarker = defs1.append('marker')
        .attr('id', 'arrow')
        .attr('markerUnits', 'strokeWidth')
        .attr('markerWidth', 8)
        .attr('markerHeight', 8)
        .attr('viewBox', '0 0 8')
        .attr('refX', 4)
        .attr('refY', 4)
        .attr('orient', 'auto')
        //绘制直线箭头
      const arrow_path = 'M2,2 L6,4 L2,6 L4,4 L2,2'
      arrowMarker.append('path')
        .attr('d', arrow_path)
        .attr('fill', '#000')
    },
    // 返回唯一标识
    getUUID() {
      return generateUUID(16, 36)
    },
    //工具栏拖动
    appendSvgNode(newDiv, parDiv, e, odiv) {
      //节点相对开始节点偏移高度
      let offTop = 0
      //随机生成id
      const id = this.getUUID()
      let nodeType = 'start'
      console.log('uuid', id)
      //节点id
      const oldNodeId = odiv.id
      //节点偏移高度
      const oldTop = odiv.offsetTop
      //相对svg x坐标
      const left = parseFloat(newDiv.style.left) - 460
      let count = 0
      //计算节点偏移量
      if (oldNodeId === 'flowNode') {
        nodeType = 'flow'
        offTop = 50
      } else if (oldNodeId === 'endNode') {
        nodeType = 'end'
        offTop = 100
      }
      // 动态生成名字
      const origName = odiv.innerText.trim()
      let nodeName = origName
      // let index = 1
      for (let i = 0; i < this.nodeData.length; i++) {
        const node = this.nodeData[i]
        if (node.nodeType === nodeType) {
          count++
        }
      }
      if (count > 0 && nodeType === 'start') {
        this.$messageInfo('error', '已有开始节点，请勿重复添加')
      } else if (count > 0 && nodeType === 'end') {
        this.$messageInfo('error', '已有结束节点，请勿重复添加')
      } else {
        nodeName = origName + count

        //相对svg y坐标（含滚动条高度）
        const top = parseFloat(newDiv.style.top) - oldTop + this.$refs.canvs.scrollTop + offTop
        // this.addCanvsNode(id, left, top)
        const data = {
          id: id,
          left: left,
          top: top,
          name: nodeName,
          scaleDays: 0,
          fixedDays: 0,
          advanceDays: 0,
          delayedDays: 0,
          nodeType: nodeType,
          iscritical: true,
          parentiid: '',
          wbsflag: '0',
          wbspath: '1.' + (this.nodeData.length + 1)
        }
        //判断是否可以添加节点
        if (this.appendNode) {
          //添加数据
          this.nodeData.push(data)
          //添加事件
          clearTimeout(this.timer) //清除延迟执行
          this.timer = setTimeout(() => { //设置延迟执行
            const g = d3.select('#group' + id)
            this.addEventByGroup(g, id)
          }, 500)
        }
      }


      //删除拖拽克隆的节点
      parDiv.removeChild(newDiv)

    },
    //画布添加节点
    addCanvsNode(id, left, top) {
      let pointArray = []
      console.log('style-h', this.$refs.canvs.scrollTop)
      console.log('style-w', top)
      //判断是否可以添加节点
      if (this.appendNode) {
        //获取svg
        const svg = d3.select('#dagSvg')
        //添加g标签
        const g = svg.append('g')
          .attr('id', 'group' + id)
          .on('mouseover', function() {
            d3.select('#group' + id).selectAll('circle')
              .attr('fill', '#000')
              .attr('cursor', 'crosshair')
          })
          .on('mouseout', function() {
            d3.select('#group' + id).selectAll('circle')
              .attr('fill', 'none')
              .attr('cursor', 'inherit')
          })

        //添加矩形节点
        this.drawRect(g, 'outRect' + id, 4, 4, this.Rectangle.height, this.Rectangle.width,
          'transparent', '#E0E3E7', 1, 'round', 'round', 'move', left, top)
        // g.append('rect')
        //   .attr('id', 'node' + id)
        //   .attr('rx', 4)
        //   .attr('ry', 4)
        //   .attr('height', this.Rectangle.height)
        //   .attr('width', this.Rectangle.width)
        //   .attr('fill', 'transparent')
        //   .attr('stroke', '#E0E3E7')
        //   .attr('stroke-width', 1)
        //   .attr('stroke-linecap', 'round')
        //   .attr('stroke-linejoin', 'round')
        //   .attr('transform', `translate(${left}, ${top})`)
        //   .style('cursor', 'move')

        //添加外点矩形

        g.append('rect')
          .attr('class', 'outRect')
          .attr('id', 'outRect' + id)
          .attr('height', this.Rectangle.height + this.outNodeMargin * 2)
          .attr('width', this.Rectangle.width + this.outNodeMargin * 2)
          .attr('fill', 'transparent')
          .attr('stroke', '#E0E3E7')
          .attr('stroke-dasharray', '10')
          .attr('stroke-width', 1)
          .attr('stroke-linecap', 'round')
          .attr('stroke-linejoin', 'round')
          .attr('transform', `translate(${left - this.outNodeMargin}, ${top - this.outNodeMargin})`)

        //添加锚点
        g.append('circle')
          .attr('r', 2)
          .attr('cx', left + this.Rectangle.width / 2)
          .attr('cy', top)
          .attr('fill', 'none')
          .attr('cursor', 'inherit')
          .on('mousedown', () => {
            console.log('锚点ex', d3.event.x)
            console.log('锚点ey', d3.event.y)
          })
          .on('mousemove', () => {
            console.log('锚点ex', d3.event.x)
            console.log('锚点ey', d3.event.y)
          })

        g.append('circle')
          .attr('r', 2)
          .attr('cx', left + this.Rectangle.width / 2)
          .attr('cy', top + this.Rectangle.height)
          .attr('fill', 'none')
          .attr('cursor', 'inherit')

        g.append('circle')
          .attr('r', 2)
          .attr('cx', left)
          .attr('cy', top + this.Rectangle.height / 2)
          .attr('fill', 'none')
          .attr('cursor', 'inherit')

        g.append('circle')
          .attr('r', 2)
          .attr('cx', left + this.Rectangle.width)
          .attr('cy', top + this.Rectangle.height / 2)
          .attr('fill', 'none')
          .attr('cursor', 'inherit')

        //添加文字
        g.append('text')
          .attr('id', '03')
          .attr('x', left + this.Rectangle.width / 4)
          .attr('y', top + this.Rectangle.height * 0.7)
          .attr('font-family', 'Verdana')
          .attr('font-size', 12)
          .attr('fill', '')
          .attr('text-anchor', 'start')
          .attr('cursor', 'move')
          .text('开始节点0001')





        const dragPoint = d3.drag()
          .on('start', dragedPointStart) // 拖动开始，触发一次
          .on('drag', dragPointing) // 拖动中，触发多次
          .on('end', dragPointEnd) // 拖动结束，触发一次
          //
        svg.selectAll('circle')
          .call(dragPoint)
      }
      function dragedPointStart() {
        this.dragClone = d3.select(this)
          .clone(true)
        console.log('this', this.dragClone)
        const array = [this.dragClone.attr('cx'), this.dragClone.attr('cy') - 1]
        pointArray = []
        pointArray.push(array)
        console.log('shsiz ', pointArray)
        // drawLine((pointArray))
      }
      function dragPointing() {
        const array = [d3.event.x, d3.event.y]
        if (pointArray.length > 1) {
          pointArray.pop()
        }
        pointArray.push(array)
        console.log('shsiz ', pointArray)
        drawLine((pointArray))
      }
      function dragPointEnd() {
        this.dragClone.remove()
      }
      function drawLine(data) {

        const lineGenerator = d3.line()
        const pathString = lineGenerator(data)
        const g = d3.selectAll('g')
        g.selectAll('path').remove()
        g.append('path')
          .attr('d', pathString)
          .attr('stroke', 'steelblue')
          .attr('stroke-width', 3)
          .attr('fill', 'none')
        // .attr('marker-start', 'url(#circle)')
          .attr('marker-end', 'url(#arrow)')
      }

    },
    /**
       * 画矩形
       *
       * @author        HangerZou
       * @createDate    2021-06-28
       * @version       v1.0
       * @param sel       selection/selections
       * @param id      id
       * @param rx      圆角
       * @param ry      圆角
       * @param height  矩形高度
       * @param width   矩形宽度
       * @param color   填充色
       * @param left    水平平移距离
       * @param top     垂直平移距离
       */
    drawRect(sel, id, rx, ry, height, width, color, stroke, strokeWidth, strokeLinecap, strokeLinejoin, cursor, left, top) {
      sel.append('rect')
        .attr('id', id)
        .attr('rx', rx)
        .attr('ry', ry)
        .attr('height', height)
        .attr('width', width)
        .attr('fill', color)
        .attr('stroke', stroke)
        .attr('stroke-width', 2)
        .attr('stroke-linecap', strokeWidth)
        .attr('stroke-linejoin', strokeLinecap)
        .style('cursor', cursor)
        .attr('transform', `translate(${left}, ${top})`)
    },
    /**
       * 获取G元素的XY坐标位置
       *
       * @author      ZhengWei(HY)
       * @createDate  2018-10-23
       * @version     v1.0
       */
    getGXY(i_G) {
      var v_Ret = i_G.attr('transform').replace('translate(', '').replace(')', '')

      if (v_Ret.indexOf(',') >= 0) {
        return v_Ret.split(',')
      } else if (v_Ret.indexOf(' ') >= 0) {
        /* IE浏览器有用空格分割位置XY的情况 */
        return v_Ret.split(' ')
      } else {
        return (v_Ret + ',0').split(',')
      }
    },
    //睡眠函数
    sleep(numberMills) {
      let now = new Date()
      let flag = false
      const exitTime = now.getTime() + numberMills
      // eslint-disable-next-line no-constant-condition
      while (true) {
        now = new Date()
        if (now.getTime() > exitTime) {
          flag = true
          return flag
        }
      }
    }
  }
}
</script>
<style scoped>
  .node {
    /*margin-left: 20px;*/
    border:1px dashed #E0E3E7;
    border-radius: 5px;
    height:30px;
    width:120px;
    padding: 6px;
    position: absolute;
  }
  /deep/ .el-tabs__item {
    height: 4vh;
    font-size: 12px;
  }
  /deep/ .el-tabs__content {
    overflow: hidden;
    position: relative;
    height: 26vh;
  }
  /deep/ .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 9px;
  }
  /deep/ .el-form-item__label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 13px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
  }
  /deep/ .el-input-number--mini {
    width: 100%;
    line-height: 26px;
  }
  #menu {
    width: 12em;
    height: auto;
    overflow: hidden; /*隐藏溢出的元素*/
    border: 1px solid #9cc;
    /*box-shadow: 0 1px 1px #888, 1px 0 1px #ccc;*/
    box-shadow: 0 2px 4px rgb(3, 52, 13), 0 0 6px rgba(0, 253, 253, 0.04);
    /*box-shadow: 0 0 0 5px rgb(16, 238, 190),*/
    /*0 0 0 10px #fff,*/
    /*-15px -15px rgb(224, 144, 144),*/
    /*15px 15px  rgb(224, 144, 144);*/
    position: absolute;
    display: none;
    background: #ffffff;
    z-index: 10;
  }
  /*name 居中*/
  .tName /deep/.el-input__inner {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #606266;
    font-weight: bold;
    display: inline-block;
    font-size: 18px;
    height: 40px;
    line-height: 40px;
    letter-spacing:0.3em;
    outline: 0;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
    text-align: center;
  }
  .disable {
    height: 100%;
    background-color: #dedddd;
    pointer-events: none;
    cursor:pointer
  }
  .el-card {
    border: 0px;
    border-radius: 0px;
    transition: all .1s;
  }
  .el-card:hover{
    /*margin-top: -5px;*/
    background-color: #99cccc;
  }
  .cardStyle {
    color: #3a71a8;
    font-size: 11px;
    text-align: left;
  }
</style>
